window.addEventListener("DOMContentLoaded", () => {
  // Initialize tabination (click-based tab switching)
  initTabination();
  // Add scroll event listener to the window
  const radioButtons = document.querySelectorAll(
    '.collection-item input[type="radio"]'
  );
  let selectedRadioArray = [];

  radioButtons.forEach((radioButton) => {
    radioButton.addEventListener("change", (event) => {
      let currentTarget = event.currentTarget;
      let addtobox = currentTarget
        .closest(".collection-item")
        .querySelector(".product-selectVarient");
      selectedRadioArray = Array.from(
        currentTarget
          .closest(".collection-item")
          .querySelectorAll('input[type="radio"]:checked')
      ).map((radio) => radio.value);
      console.log(currentTarget.value);
      const variantPicker = currentTarget
        .closest(".collection-item")
        .querySelector("#product_variant");
      const variantLabel = currentTarget.closest(
        ".variant-radio-wrapper"
      ).previousElementSibling;
      variantLabel.querySelector("span.vat-set-vl").innerText =
        "- " + currentTarget.value;
      const jsonString = variantPicker.textContent.trim();
      const variantsInfo = JSON.parse(jsonString);
      console.log("jsonDataString", variantsInfo);
      const selectedVariant = variantsInfo.find((variant) => {
        return variant.options.every((option, index) => {
          return option === selectedRadioArray[index];
        });
      });

      if (selectedVariant != undefined) {
        const selectedVariantId = selectedVariant.id;
        addtobox.dataset.idVariant = selectedVariantId;
      }
    });
  });
});
document.getElementById("searchInput")?.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });

// Select all elements with the class "varient-close-popup"
const closeButtons = document.querySelectorAll(".varient-close-popup");

closeButtons.forEach((button) => {
  button.addEventListener("click", function (event) {
    event.preventDefault();
    var productMeta = event.target.closest(".product-item__inner");
    var variantPopup = productMeta.querySelector(".variant-popup");
    var addToBoxBtn = document.querySelectorAll(".deals-page .add-to-box .btn");

    if (variantPopup) {
      variantPopup.classList.add("hidden");
      variantPopup.classList.remove("show");
      productMeta.classList.remove("show");
      addToBoxBtn.forEach((addbtn) => {
        addbtn.classList.remove("disabled");
      });
    }
  });
});

var checkboxes = document.querySelectorAll("#checkboxes");
var addToCartBtn = document.querySelector(".product-form__cart-submit");
addToCartBtn.setAttribute("disabled", "disabled");
// Attach click event listener to each div element
checkboxes.forEach(function (checkbox) {
  checkbox.addEventListener("click", function () {
    // Get the value of the data-button-id attribute
    var buttonId = this.getAttribute("data-button-id");
    var limitId = this.getAttribute("data-product-limit");
    var sectionId = this.getAttribute("data-sec-id");
    var productName = this.getAttribute("data-product-name");

    // For hide and show add to cart button
    // var addedToCartElements = document.querySelectorAll(".added_to_cart");

    // var anyNotDisplayedBlock = false;

    // // Iterate over each element
    // addedToCartElements.forEach(function (element) {
    //   if (getComputedStyle(element).display !== "block") {
    //     anyNotDisplayedBlock = true;
    //   }
    // });

    // if (!anyNotDisplayedBlock) {
    //   addToCartBtn.removeAttribute("disabled");
    //   addToCartBtn.classList.remove("btn--secondary");
    //   addToCartBtn.classList.add("btn--primary");
    // } else {
    //   addToCartBtn.setAttribute("disabled", "disabled");
    //   addToCartBtn.classList.add("btn--secondary");
    //   addToCartBtn.classList.remove("btn--primary");
    // }

    var checkboxMain = document.getElementById(buttonId);

    // Attach click event listener
    checkboxMain.addEventListener("click", function (event) {
      function closePopup(event) {
        event.preventDefault(); // Prevent the default link behavior

        // Get the data-popup attribute value from the clicked close button
        const popupId = event.currentTarget.getAttribute("data-popup");

        // Find the popup with the matching data-popup attribute
        const popup = document.querySelector(
          `.varient-popup[data-popup="${popupId}"]`
        );

        // Hide the popup
        if (popup) {
          popup.classList.remove("active");
          checkboxMain.classList.remove("button");
          checkboxMain.classList.add("product-varientbutton");
          checkboxMain.checked = false;
        }
      }

      // Add event listener to all close buttons
      document.querySelectorAll(".close-popup").forEach((button) => {
        button.addEventListener("click", closePopup);
      });
      // Check if the checkbox is checked
      if (event.target.classList.contains("product-varientbutton")) {
        console.log("Popup toggled");
        var variantPopup = document.querySelector(
          `.varient-popup[data-popup="${buttonId}"]`
        );
        if(variantPopup){
        variantPopup.classList.add("active");
        }
        checkboxMain.classList.add("button");
        checkboxMain.classList.remove("product-varientbutton");
        checkboxMain.checked = false;
        console.log("yesss");
        return;
      }

      // Rest of the code for handling checkboxes
      var productMeta = event.target.closest(".product-item__inner");
      var variantPopup = productMeta.querySelector(".variant-popup");
      var addToBoxBtn = document.querySelectorAll(
        ".deals-page .add-to-box .btn"
      );
      var oldVat = productMeta.querySelector(".Size_var_wrap");
      if (oldVat) {
        var hasVariants = oldVat.children.length > 0;
      }
      if (hasVariants) {
        // For hide and show add to cart button
        // var addedToCartElements = document.querySelectorAll(".added_to_cart");

        // var anyNotDisplayedBlock = false;

        // // Iterate over each element
        // addedToCartElements.forEach(function (element) {
        //   if (getComputedStyle(element).display !== "block") {
        //     anyNotDisplayedBlock = true;
        //   }
        // });

        // if (!anyNotDisplayedBlock) {
        //   addToCartBtn.removeAttribute("disabled");
        //   addToCartBtn.classList.remove("btn--secondary");
        //   addToCartBtn.classList.add("btn--primary");
        // } else {
        //   addToCartBtn.setAttribute("disabled", "disabled");
        //   addToCartBtn.classList.add("btn--secondary");
        //   addToCartBtn.classList.remove("btn--primary");
        // }

        // Check if the checkbox is checked
        // Function to close the popup

        var label = event.target.nextElementSibling;
        var button = checkboxMain.parentElement;
        button.classList.remove("btn--secondary");
        button.classList.add("btn--primary");
        if (!event.target.checked) {
          selectItem(event, limitId, sectionId, productName, checkboxMain);
        } else {
          productMeta.classList.add("show");
          // addToBoxBtn.forEach(addbtn => {
          //     addbtn.classList.add('disabled');
          // });
          // Get all radio buttons
          var radioButtons = document.querySelectorAll(
            'input[type="radio"][data-variant-input]'
          );

          // Attach change event listener to each radio button
          radioButtons.forEach(function (radioButton) {
            radioButton.addEventListener("change", function (events) {
              // Get the selected radio button's data-variant-id
              var selectedVariantId =
                events.target.getAttribute("data-variant-id");
              var selectedbuttonId =
                events.target.getAttribute("data-button-id");
              console.log("selectedbuttonId s");
              console.log(selectedbuttonId);
              // Get the corresponding checkbox
              var checkbox = document.querySelector(
                "#" + selectedbuttonId + '[type="checkbox"]'
              );

              // Update the checkbox's data-variant-id attribute
              checkbox.setAttribute("data-id-variant", selectedVariantId);
              selectItem(event, limitId, sectionId, productName, checkboxMain);
              variantPopup.classList.add("hidden");
              variantPopup.classList.remove("show");
              productMeta.classList.remove("show");
              addToBoxBtn.forEach((addbtn) => {
                addbtn.classList.remove("disabled");
              });
            });
          });
          radioButtons.forEach(function (radioButton) {
            radioButton.addEventListener("click", function (events) {
              // Get the selected radio button's data-variant-id
              var selectedVariantId =
                events.target.getAttribute("data-variant-id");
              var selectedVariantPrice =
                events.target.getAttribute("data-variant-price");
              var selectedbuttonId =
                events.target.getAttribute("data-button-id");
              console.log("selectedbuttonId s");
              console.log(selectedbuttonId);
              // Get the corresponding checkbox
              var checkbox = document.querySelector(
                "#" + selectedbuttonId + '[type="checkbox"]'
              );

              // Update the checkbox's data-variant-id attribute
              checkbox.setAttribute("data-id-variant", selectedVariantId);
              const variantPrice = parseInt(selectedVariantPrice);
              checkbox.setAttribute("data-price-variant", variantPrice);
              selectItem(event, limitId, sectionId, productName, checkboxMain);
              variantPopup.classList.add("hidden");
              variantPopup.classList.remove("show");
              productMeta.classList.remove("show");
              addToBoxBtn.forEach((addbtn) => {
                addbtn.classList.remove("disabled");
              });
            });
          });
        }
      } else {
        selectItem(event, limitId, sectionId, productName, checkboxMain);
      }
    });
  });
});

var totalPrice = 0;
var totalQuantity = 0;

// NEW: recalc from all checkboxes for this section
function recalcTotals(sectionId) {
  totalPrice = 0;
  totalQuantity = 0;

  const all = document.querySelectorAll(
    '#checkboxes input[data-id-products="' + sectionId + '"]'
  );

  all.forEach(function (cb) {
    if (!cb.checked) return;

    var q = parseInt(cb.getAttribute("data-quantity")) || 0;
    if (q <= 0) return;

    var price = parseFloat(cb.getAttribute("data-price-variant")) || 0;
    totalQuantity += q;
    totalPrice += price * q;
  });
}

function selectItem(event, limitId, sectionId, productName, checkboxMain) {
   
    var totalLimitContent = document.querySelector('.offer-collection-grid__product .tab-content');
    var totalLimit = totalLimitContent.getAttribute('data-total-limit');
    console.log("totalLimit: ", totalLimit);
    var addToCartBtn = document.querySelector(".product-form__cart-submit");

     // For hide and show add to cart button
     var addedToCartElements = document.querySelectorAll(".added_to_cart");
        
     var anyNotDisplayedBlock = false;
     // Iterate over each element
     addedToCartElements.forEach(function(element) {
         if (getComputedStyle(element).display !== 'block') {
             anyNotDisplayedBlock = true;
             console.log("here");
         }
     });
     
     if (!anyNotDisplayedBlock) {
         addToCartBtn.removeAttribute("disabled"); 
         addToCartBtn.classList.remove("btn--secondary"); 
         addToCartBtn.classList.add("btn--primary"); 
     } else {
         addToCartBtn.setAttribute("disabled", "disabled"); 
         addToCartBtn.classList.add("btn--secondary"); 
         addToCartBtn.classList.remove("btn--primary"); 
     }
     
    let productVariant = checkboxMain.getAttribute("data-id-variant");
    let productImage  = checkboxMain.getAttribute("data-product-image");
        var label = event.target.nextElementSibling;
        var button = checkboxMain.parentElement;
         button.classList.remove('btn--secondary');
         button.classList.add('btn--primary');
        label.textContent = "";
        if (event.target.checked) {
            createHiddenInput(productName);
            fillOneDesktopSlot(productVariant, productImage, productName, sectionId)
            label.textContent = "Remove from Box";
        } else {
            removeHiddenInput(productName);
            var button = checkboxMain.parentElement;
            button.classList.remove('btn--primary');
            button.classList.add('btn--secondary');
            label.textContent = "Add to Box";
            clearOneDesktopSlot(productVariant, sectionId); 
        }

        const checkboxesCount = document.querySelectorAll('#checkboxes input[data-id-products="'+ sectionId +'"]');
        const checkboxes = document.querySelectorAll('#checkboxes input[data-id-products="'+ sectionId +'"]');
        const showCount = document.querySelector('#checkbox_count_'+ sectionId +'_product');
        const addedSec = document.querySelector('#cart_'+ sectionId +'_added');
        const tabComplete = document.querySelector('.parent_'+ sectionId);
        const allCheckboxes = document.querySelectorAll('.select-btn');

        let checkedCount = 0;
        let totalPrice = 0;
        let selectedCount = 0;
        checkboxesCount.forEach(function(checkbox) {
            if (checkbox.checked) {
                checkedCount++;
            }
        });

         allCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
            const price = parseFloat(checkbox.getAttribute('data-price-variant'));
            totalPrice += price;
            selectedCount++;
            }
        });


        if (totalPrice) {
            document.getElementById('total-price').style.display = "block";
            document.getElementById('total-price').textContent = "₹ " + totalPrice.toFixed(2).replace(/\.00$/, '');
            document.getElementById('total-products').textContent = "(" + selectedCount + ")";
            document.querySelector('.products-count').style.display = 'block';
        } else {
            document.querySelector('.products-count').style.display = 'none';
            document.getElementById('total-price').style.display = "none";
        }
       
        if (limitId == checkedCount) {
            checkboxes.forEach(function(checkbox) {
                if(showCount){
                showCount.style.display = "none";
                }
                if(addedSec){
                addedSec.style.display = "block";
                }
                if(tabComplete){
                tabComplete.classList.add('complete');
                }
                if(showCount){
                showCount.textContent = checkedCount;
            }
                data = checkbox.getAttribute('data-step');
                var activeTab = document.querySelector('.tab-content[data-id="tab' + data + '"]');
                activeTab.style.marginTop = '3%';
                var nextTab = activeTab.nextElementSibling;
                if (nextTab) {
                    activeTab.classList.remove('active-tab-content');
                    nextTab.classList.add('active-tab-content');
                    // Add margin top to the current tab
                    
                    nextTab.scrollIntoView({ behavior: 'smooth' });
                    var scrollPosition = nextTab.getBoundingClientRect().top - (window.innerHeight * 0.2);
                    window.scrollBy({ top: scrollPosition, behavior: 'smooth' });
                }
                if (!checkbox.checked) {
                    checkbox.disabled = true;
                    checkbox.classList.add("disabled");
                }
            });
        } else {
            if (checkedCount != 0) {
                addedSec.style.display = "none";
                if(showCount){
                showCount.style.display = "block";
                showCount.textContent = checkedCount;
            }
            
            } else {
                if(showCount){
                showCount.style.display = "none";
                }
                if(addedSec){
                addedSec.style.display = "none";
                }
                if(showCount){
                showCount.textContent = checkedCount;
                }
            }
            checkboxes.forEach(function(checkbox) {
                if (!checkbox.checked) {
                    checkbox.disabled = false;
                    checkbox.classList.remove("disabled");
                }
            });
        }

        if (totalLimit == selectedCount) {
          addToCartBtn.removeAttribute("disabled");
          addToCartBtn.classList.remove("btn--secondary");
          addToCartBtn.classList.add("btn--primary");
        } else {
          addToCartBtn.setAttribute("disabled", "disabled");
          addToCartBtn.classList.add("btn--secondary");
          addToCartBtn.classList.remove("btn--primary");
        }
}
function fillOneDesktopSlot(variantId, productImage, productName, sectionId) {
  if (window.innerWidth < 767) return;

  const slots = document.querySelectorAll('.desktop-products .product-detail');
  for (const slot of slots) {
    const filled = slot.getAttribute('data-filled') === 'true';
    const tabId  = slot.closest('.desktop-products')?.getAttribute('data-product-section-id');

    if (!filled && tabId == sectionId) {
      const img = slot.querySelector('.desktop-product-image');

      slot.setAttribute('data-variant-id', variantId);
      slot.setAttribute('data-filled', 'true');
      slot.setAttribute('data-section-id', sectionId);

      // update the image
      if (img) {
        img.src = productImage;
        img.alt = productName;
      }

      // create title dynamically if missing
      let ttl = slot.querySelector('.desktop-product-title');
      if (!ttl) {
        ttl = document.createElement('h3');
        ttl.className = 'desktop-product-title';
        slot.appendChild(ttl);
      }
      ttl.textContent = productName;

      break;
    }
  }
}

function clearOneDesktopSlot(variantId, sectionId) {
  if (window.innerWidth < 767) return;

  const slots = document.querySelectorAll('.desktop-products .product-detail');
  for (const slot of slots) {
    if (
      slot.getAttribute('data-variant-id') === String(variantId) &&
      slot.getAttribute('data-section-id') === sectionId
    ) {
      const img = slot.querySelector('.desktop-product-image');

      // reset attributes
      slot.setAttribute('data-variant-id', '');
      slot.setAttribute('data-filled', 'false');
      slot.setAttribute('data-section-id', 0);

      // reset image to placeholder
      if (img) {
        const placeholder = img.getAttribute('data-placeholder-src') || '';
        img.src = placeholder;
        img.alt = '';
      }

      // remove title dynamically
      const ttl = slot.querySelector('.desktop-product-title');
      if (ttl) ttl.remove();

      break;
    }
  }
}


function updatePriceAndQuantity(totalPrice, totalQuantity, limitId, sectionId) {
  const checkboxesCount = document.querySelectorAll(
    '#checkboxes input[data-id-products="' + sectionId + '"]'
  );
  const checkboxes = document.querySelectorAll(
    '#checkboxes input[data-id-products="' + sectionId + '"]'
  );
  const showCount = document.querySelector(
    "#checkbox_count_" + sectionId + "_product"
  );
  const addedSec = document.querySelector("#cart_" + sectionId + "_added");
  const tabComplete = document.querySelector(".parent_" + sectionId);
  const allCheckboxes = document.querySelectorAll(".select-btn");
  var addToCartBtn = document.querySelector(".product-form__cart-submit");

  console.log(
    "limitId and totalQuantity and totalPrice: ",
    limitId,
    totalQuantity,
    totalPrice
  );
  if (totalPrice) {
    document.getElementById("total-price").style.display = "block";
    document.getElementById("total-price").textContent =
      "₹" + totalPrice.toFixed(2).replace(/\.00$/, "");
    document.getElementById("total-products").textContent =
      "(" + totalQuantity + ")";
    document.querySelector(".products-count").style.display = "block";
  } else {
    document.querySelector(".products-count").style.display = "none";
    document.getElementById("total-price").style.display = "none";
  }

  if (limitId == totalQuantity) {
    console.log("limitId: ", limitId);
    console.log("totalQuantity: ", totalQuantity);
    addToCartBtn.removeAttribute("disabled");
    addToCartBtn.classList.remove("btn--secondary");
    addToCartBtn.classList.add("btn--primary");

    checkboxes.forEach(function (checkbox) {
      if(showCount){
      showCount.style.display = "none";
      }
      if(addedSec){
      addedSec.style.display = "block";
      }
      if(tabComplete){
      tabComplete.classList.add("complete"); 
      }
      if(showCount){
      showCount.textContent = totalQuantity;
      }
      data = checkbox.getAttribute("data-step");
      var activeTab = document.querySelector(
        '.tab-content[data-id="tab' + data + '"]'
      );
      activeTab.style.marginTop = "3%";
      var nextTab = activeTab.nextElementSibling;
      if (nextTab) {
        activeTab.classList.remove("active-tab-content");
        nextTab.classList.add("active-tab-content");
        // Add margin top to the current tab

        nextTab.scrollIntoView({ behavior: "smooth" });
        var scrollPosition =
          nextTab.getBoundingClientRect().top - window.innerHeight * 0.2;
        window.scrollBy({ top: scrollPosition, behavior: "smooth" });
      }
      if (!checkbox.checked) {
        checkbox.disabled = true;
        checkbox.classList.add("disabled");
      }
    });
  } else {
      addToCartBtn.setAttribute("disabled", "disabled");
      addToCartBtn.classList.add("btn--secondary");
      addToCartBtn.classList.remove("btn--primary");
    if (totalQuantity != 0) {
      if(addedSec){
      addedSec.style.display = "none";
      }
      if(showCount){
      showCount.style.display = "block";
      showCount.textContent = totalQuantity;
      }
    } else {
      if(showCount){
      showCount.style.display = "none";
      }
      if(addedSec){
      addedSec.style.display = "none";
      }
      showCount.textContent = totalQuantity;
    }
    checkboxes.forEach(function (checkbox) {
      if (!checkbox.checked) {
        checkbox.disabled = false;
        checkbox.classList.remove("disabled");
      }
    });
  }
}

function createHiddenInput(productName) {
  const hiddenInputsContainer = document.getElementById(
    "hiddenInputsContainer"
  );
  // Check if an input with the same value already exists
  const existingInput = hiddenInputsContainer.querySelector(
    `input[value="${productName}"]`
  );
  if (existingInput) {
    return; // Exit the function if the input already exists
  }
  hiddenInputsContainer.querySelectorAll("input").forEach((input, index) => {
    input.name = `properties[ITEM ${index + 1}]`;
  });
  hiddenInputsContainer.querySelectorAll("input").forEach((input, index) => {
    input.name = `properties[ITEM ${index + 1}]`;
  });
  let inputCount = 1;

  // Find the highest count
  hiddenInputsContainer.querySelectorAll("input").forEach((input) => {
    const regex = /properties\[ITEM\s+(\d+)\]/;
    const match = regex.exec(input.name);
    if (match) {
      inputCount = Math.max(inputCount, parseInt(match[1]) + 1);
    }
  });

  // Create a new input with the incremented count
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = `properties[ITEM ${inputCount}]`;
  input.value = productName;
  hiddenInputsContainer.appendChild(input);
}

function removeHiddenInput(productName) {
  const hiddenInputsContainer = document.getElementById(
    "hiddenInputsContainer"
  );
  hiddenInputsContainer.querySelectorAll("input").forEach((input, index) => {
    input.name = `properties[ITEM ${index + 1}]`;
  });
  const inputToRemove = hiddenInputsContainer.querySelector(
    `input[value="${productName}"]`
  );
  if (inputToRemove) {
    hiddenInputsContainer.removeChild(inputToRemove);
  }
}

// scrollSection function removed - using tabination instead

function imageAnimation() {
  var parentDivs = document.querySelectorAll(".product-item__inner");
  parentDivs.forEach(function (parentDiv) {
    var image = parentDiv.querySelector(".product-item__image--two");

    parentDiv.addEventListener("mouseover", function () {
      image.classList.add("active");
    });

    parentDiv.addEventListener("mouseout", function () {
      image.classList.remove("active");
    });
  });
}

function initTabination() {
  // Get all tab links and tab contents
  const tabs = document.querySelectorAll(".tab");
  const tabContents = document.querySelectorAll(".tab-content");

  // Return early if no tabs found
  if (tabs.length === 0 || tabContents.length === 0) {
    return;
  }

  const scrollTabsToTop = () => {
    const sectionWrapper = document.querySelector(".section.deals-template");
    const tabMenu = document.querySelector(".tab-menu.sticky-header");
    const stickyForm = document.querySelector(".sticky-cart__form");
    const activeContent = document.querySelector(".tab-content.active-tab-content");

    const headerHeight = document.querySelector("header")?.offsetHeight || 60;
    const tabMenuHeight = tabMenu ? tabMenu.offsetHeight : 0;

    const targetEl =
      sectionWrapper ||
      tabMenu ||
      stickyForm ||
      activeContent ||
      document.body;

    const targetPosition =
      targetEl.getBoundingClientRect().top +
      window.pageYOffset -
      (headerHeight + tabMenuHeight + 16);

    window.scrollTo({
      top: Math.max(0, targetPosition),
      behavior: "smooth",
    });
  };

  // Add click event listeners to each tab
  tabs.forEach((tab) => {
    tab.addEventListener("click", function (event) {
      event.preventDefault();

      // Get the tab ID from the clicked tab
      const tabId = tab.getAttribute("data-id");

      if (!tabId) {
        console.warn("Tab clicked but no data-id attribute found");
        return;
      }

      // Remove active-tab class from all tabs
      tabs.forEach((t) => {
        t.classList.remove("active-tab");
      });

      // Add active-tab class to clicked tab
      tab.classList.add("active-tab");

      // Hide all tab contents
      tabContents.forEach((content) => {
        content.classList.remove("active-tab-content");
      });

      // Show the corresponding tab content
      const targetContent = document.querySelector(
        '.tab-content[data-id="' + tabId + '"]'
      );
      if (targetContent) {
        targetContent.classList.add("active-tab-content");
        scrollTabsToTop();
      } else {
        console.warn("Tab content not found for tab ID:", tabId);
      }
    });
  });

  // Ensure initial state: Only first tab and its content should be active
  // Hide all tab contents first
  tabContents.forEach((content) => {
    content.classList.remove("active-tab-content");
  });

  // Remove active-tab from all tabs
  tabs.forEach((t) => {
    t.classList.remove("active-tab");
  });

  // Activate first tab and its content
  if (tabs.length > 0 && tabContents.length > 0) {
    const firstTab = tabs[0];
    const firstTabId = firstTab.getAttribute("data-id");
    const firstContent = document.querySelector('.tab-content[data-id="' + firstTabId + '"]');

    if (firstTab && firstContent) {
      firstTab.classList.add("active-tab");
      firstContent.classList.add("active-tab-content");
    }
  }
}

async function addTocartDiscount(productIds, totalPrice, offerPrice, hashResult) {
  try {
        let response = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
                "Authorization": `Bearer ${window.sessionToken}`
            },
            body: JSON.stringify({
                variant_IDs: productIds,
                total_price: totalPrice,
                offer_price: offerPrice,
                htop: hashResult,
              store_name: "Villain",
            })
        });
        let res = await response.json();
        let discount_code = res['Discount code'];
        console.log('discount_code generated:', discount_code);
        
        // Apply discount code via Shopify discount endpoint
        if (discount_code) {
          try {
            const discountResponse = await fetch(`/discount/${discount_code}`, {
              method: 'GET',
              credentials: 'include' // Include cookies for session
            });
            if (discountResponse.ok) {
              console.log("Discount code applied successfully:", discount_code);
            } else {
              console.warn("Discount application response not OK:", discountResponse.status);
            }
          } catch (discountError) {
            console.error("Error applying discount:", discountError);
          }
        }
        
        // Return the discount code so it can be used
        return { code: discount_code };
  } catch (error) {
      console.error('Error generating discount:', error);
      return { code: null };
  }
}

async function replaceCartDiscount(productIds, totalPrice, offerPrice, hashResult) {
  try {
    let response = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `Bearer ${window.sessionToken}`
        },
        body: JSON.stringify({
            variant_IDs: productIds,
            total_price: totalPrice,
            offer_price: offerPrice,
            htop: hashResult,
          store_name: "Villain",
        })
    });
    let res = await response.json();
    let discount_code = res['Discount code'];
    console.log('discount_code generated (replace):', discount_code);
    
        // Apply discount code via Shopify discount endpoint
        if (discount_code) {
          try {
            const discountResponse = await fetch(`/discount/${discount_code}`, {
              method: 'GET',
              credentials: 'include' // Include cookies for session
            });
            if (discountResponse.ok) {
              console.log("Discount code applied successfully (replace):", discount_code);
            } else {
              console.warn("Discount application response not OK:", discountResponse.status);
            }
          } catch (discountError) {
            console.error("Error applying discount:", discountError);
          }
        }
    
    // Return the discount code so it can be used
    return { code: discount_code };
  } catch (error) {
    console.error('Error generating discount:', error);
    return { code: null };
  }
}

// Helper function to clear bundle items from cart (only items with "Offer" property)
// This preserves simple products that don't have the "Offer" property
async function clearBundleItemsFromCart() {
  try {
    // Get current cart to identify bundle items
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();
    
    // Build updates object to remove ONLY items with "Offer" property (bundle items)
    const updates = {};
    let bundleItemsCount = 0;
    
    cart.items.forEach((item) => {
      // Only remove items that have the "Offer" property
      if (item.properties && item.properties.Offer) {
        updates[item.key] = 0; // Set quantity to 0 to remove
        bundleItemsCount++;
      }
    });
    
    // Remove bundle items if any exist
    if (Object.keys(updates).length > 0) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });
      console.log(`Removed ${bundleItemsCount} bundle item(s) from cart`);
      
      // Get updated cart to check remaining items
      const updatedCartResponse = await fetch("/cart.js");
      const updatedCart = await updatedCartResponse.json();

      // Close any open drawer, then refresh cart drawer via AJAX but DO NOT open it
      try {
        const existingDrawer = document.querySelector('cart-drawer');
        if (existingDrawer && typeof existingDrawer.close === 'function') {
          try { existingDrawer.close(); } catch (e) { /* ignore */ }
        }
        await cartDrawer(false);
      } catch (e) {
        // Fallback: dispatch the existing refresh event
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      }

      // Update cart count bubble with actual remaining item count (best-effort)
      const cartBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (cartBubble && updatedCart.item_count !== undefined) {
        cartBubble.textContent = updatedCart.item_count;
      }

      console.log(`Cart now has ${updatedCart.item_count} item(s) remaining`);
      return true;
    }
    return false;
  } catch (error) {
    console.error("Error clearing bundle items from cart:", error);
    return false;
  }
}

// Helper function to clear all items from cart (both bundle and single products)
async function clearAllItemsFromCart() {
  try {
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();
    
    if (cart.items.length === 0) {
      return false;
    }
    
    // Build updates object to remove ALL items
    const updates = {};
    cart.items.forEach((item) => {
      updates[item.key] = 0; // Set quantity to 0 to remove
    });
    
    // Remove all items
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });
    
    console.log(`Removed all ${cart.items.length} item(s) from cart`);

    // Close any open drawer, then refresh cart drawer via AJAX but do not open it
    try {
      const existingDrawer = document.querySelector('cart-drawer');
      if (existingDrawer && typeof existingDrawer.close === 'function') {
        try { existingDrawer.close(); } catch (e) { /* ignore */ }
      }
      await cartDrawer(false);
    } catch (e) {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }

    // Update cart count bubble (best-effort)
    const cartBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (cartBubble) {
      cartBubble.textContent = '0';
    }

    return true;
  } catch (error) {
    console.error("Error clearing all items from cart:", error);
    return false;
  }
}

// Helper function to add items directly to Shopflo checkout
// Bundle items are added to cart temporarily (only for Shopflo to read), then removed immediately
// Items never appear in cart drawer - they only exist in checkout
// When combo checkout is initiated, ALL items (both bundle and single) are removed to ensure clean state
// async function addItemsToShopfloCheckout(items, discountCode) {
//   try {
//     // First, clear ALL existing items (both bundle and single products) to ensure clean state
//     // This ensures only combo products are in checkout, no single products remain
//     const existingCartResponse = await fetch("/cart.js");
//     const existingCart = await existingCartResponse.json();
    
//     if (existingCart.items.length > 0) {
//       console.log("Clearing all existing items from cart before adding combo products...");
//       await clearAllItemsFromCart();
//       await new Promise(resolve => setTimeout(resolve, 200));
//     }
    
//     // Add bundle items to cart temporarily (only for Shopflo to read, then remove immediately)
//     console.log("Adding bundle items temporarily for Shopflo checkout...");
    
//     // Add items sequentially to ensure all are added correctly
//     for (const item of items) {
//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           id: item.id,
//           quantity: item.quantity,
//           properties: item.properties
//         })
//       });
//       if (!response.ok) {
//         throw new Error(`Failed to add item ${item.id} to cart`);
//       }
//     }
    
//     // Wait for cart to update (ensures all items are processed)
//     await new Promise(resolve => setTimeout(resolve, 200));
    
//     // Apply discount if available (non-blocking - don't wait for it)
//     if (discountCode) {
//       console.log("Applying discount code...");
//       fetch(`/discount/${discountCode}`, {
//         method: 'GET',
//         credentials: 'include'
//       }).catch(err => console.warn("Discount application error:", err));
//       // Don't wait for discount - open checkout immediately
//     }
    
//     // Store timestamp when checkout opens
//     const checkoutOpenTime = Date.now();
//     window.bundleCheckoutOpenTime = checkoutOpenTime;
    
//     // Open Shopflo checkout immediately (items are in cart for Shopflo to read)
//     console.log("Opening Shopflo checkout...");
    
//     let checkoutOpened = false;
//     if (window.handleFloCheckoutBtn && typeof window.handleFloCheckoutBtn === 'function') {
//       window.handleFloCheckoutBtn();
//       checkoutOpened = true;
//     } else if (window.Shopflo && typeof window.Shopflo.checkout === 'function') {
//       window.Shopflo.checkout();
//       checkoutOpened = true;
//     } else if (window.ShopfloCheckout && typeof window.ShopfloCheckout === 'function') {
//       window.ShopfloCheckout();
//       checkoutOpened = true;
//     } else {
//       throw new Error("Shopflo checkout not available");
//     }
    
//     // Immediately remove bundle items from cart (they were never meant to stay in cart)
//     // Shopflo has already read the cart, so items remain in checkout
//     if (checkoutOpened) {
//       // Remove items immediately - they should never appear in cart
//       // Do it synchronously right after opening checkout
//       (async () => {
//         // Wait just enough for Shopflo to initialize and read cart
//         await new Promise(resolve => setTimeout(resolve, 50));
//         console.log("Removing all items from cart (they were only added temporarily for checkout)...");
//         // Remove all items (both bundle and single) to ensure clean cart
//         await clearAllItemsFromCart();
        
//         // Immediately update cart drawer to reflect empty state
//         try {
//           // Close drawer first if it's open
//           const currentCartDrawer = document.querySelector("cart-drawer");
//           if (currentCartDrawer && typeof currentCartDrawer.close === 'function') {
//             currentCartDrawer.close();
//           } else if (currentCartDrawer && currentCartDrawer.classList.contains("active")) {
//             currentCartDrawer.classList.remove("active");
//             document.body.classList.remove('overflow-hidden');
//           }
          
//           // Update cart drawer content using proper method
//           const res = await fetch("/cart?section_id=cart-drawer");
//           const html = await res.text();
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, "text/html");
          
//           // Update cart-drawer-items and cart-drawer__footer separately (proper way)
//           const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
//           for (const selector of selectors) {
//             const targetElement = document.querySelector(selector);
//             const sourceElement = doc.querySelector(selector);
//             if (targetElement && sourceElement) {
//               targetElement.replaceWith(sourceElement);
//             }
//           }
          
//           // Also update the entire cart-drawer if needed
//           const newCartDrawer = doc.querySelector("cart-drawer");
//           if (newCartDrawer && currentCartDrawer) {
//             // Update is-empty class
//             if (newCartDrawer.classList.contains("is-empty")) {
//               currentCartDrawer.classList.add("is-empty");
//             } else {
//               currentCartDrawer.classList.remove("is-empty");
//             }
//           }
          
//           // Trigger cart update event
//           const cartDrawerItems = document.querySelector("cart-drawer-items");
//           if (cartDrawerItems && typeof cartDrawerItems.announceSectionsUpdated === 'function') {
//             cartDrawerItems.announceSectionsUpdated(selectors);
//           } else {
//             document.dispatchEvent(new CustomEvent("cart:sections-updated", { bubbles: true }));
//           }
          
//           // Also update cart icon bubble
//           const cartBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
//           if (cartBubble) {
//             cartBubble.textContent = '0';
//           }
          
//           // Update cart icon bubble section
//           document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
//         } catch (error) {
//           console.error("Error updating cart drawer after checkout:", error);
//         }
//       })();
        
//         const checkPurchaseStatus = async () => {
//           try {
//             const cartResponse = await fetch("/cart.js");
//             const cart = await cartResponse.json();
            
//             // Check if cart has any items (bundle or single)
//             const hasItems = cart.items.length > 0;
            
//             // If any items exist in cart, remove them all (they should never appear in drawer)
//             // This ensures both bundle items and single products are removed
//             if (hasItems && window.bundleCheckoutOpenTime === checkoutOpenTime) {
//               console.log("Items found in cart, removing all items from drawer...");
//               await clearAllItemsFromCart();
              
//               // Update cart drawer to reflect empty state
//               try {
//                 const res = await fetch("/cart?section_id=cart-drawer");
//                 const html = await res.text();
//                 const parser = new DOMParser();
//                 const doc = parser.parseFromString(html, "text/html");
                
//                 // Update cart-drawer-items and cart-drawer__footer separately (proper way)
//                 const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
//                 for (const selector of selectors) {
//                   const targetElement = document.querySelector(selector);
//                   const sourceElement = doc.querySelector(selector);
//                   if (targetElement && sourceElement) {
//                     targetElement.replaceWith(sourceElement);
//                   }
//                 }
                
//                 // Update is-empty class
//                 const newCartDrawer = doc.querySelector("cart-drawer");
//                 const currentCartDrawer = document.querySelector("cart-drawer");
//                 if (newCartDrawer && currentCartDrawer) {
//                   if (newCartDrawer.classList.contains("is-empty")) {
//                     currentCartDrawer.classList.add("is-empty");
//                   } else {
//                     currentCartDrawer.classList.remove("is-empty");
//                   }
//                 }
                
//                 // Trigger cart update event
//                 const cartDrawerItems = document.querySelector("cart-drawer-items");
//                 if (cartDrawerItems && typeof cartDrawerItems.announceSectionsUpdated === 'function') {
//                   cartDrawerItems.announceSectionsUpdated(selectors);
//                 } else {
//                   document.dispatchEvent(new CustomEvent("cart:sections-updated", { bubbles: true }));
//                 }
//               } catch (error) {
//                 console.error("Error updating cart drawer in periodic check:", error);
//               }
//             }
            
//             // Clear stored data after checking
//             if (window.bundleCheckoutOpenTime === checkoutOpenTime) {
//               const timeSinceCheckout = Date.now() - checkoutOpenTime;
//               // After 2 minutes, clear stored data (purchase likely completed or abandoned)
//               if (timeSinceCheckout > 120000) {
//                 sessionStorage.removeItem('bundleItemsForRestore');
//                 window.bundleCheckoutOpenTime = null;
//               }
//             }
//           } catch (error) {
//             console.error("Error checking purchase status:", error);
//           }
//         };
        
//         // Listen for page visibility changes (when user returns from checkout)
//         const visibilityHandler = function() {
//           if (!document.hidden) {
//             setTimeout(checkPurchaseStatus, 1000);
//           }
//         };
//         document.addEventListener('visibilitychange', visibilityHandler);
        
//         // Also listen for window focus (when user returns to tab)
//         const focusHandler = function() {
//           setTimeout(checkPurchaseStatus, 1000);
//         };
//         window.addEventListener('focus', focusHandler);
        
//         // Periodic check (every 5 seconds) to see if checkout closed
//         const purchaseCheckInterval = setInterval(async () => {
//           try {
//             const cartResponse = await fetch("/cart.js");
//             const cart = await cartResponse.json();
            
//           const hasItems = cart.items.length > 0;
          
//           // If any items exist in cart, remove them all (they should never appear in drawer)
//           // This ensures both bundle items and single products are removed
//           if (hasItems && window.bundleCheckoutOpenTime === checkoutOpenTime) {
//             console.log("Items found in cart, removing all items from drawer...");
//             await clearAllItemsFromCart();
            
//             // Update cart drawer to reflect empty state
//             try {
//               const res = await fetch("/cart?section_id=cart-drawer");
//               const html = await res.text();
//               const parser = new DOMParser();
//               const doc = parser.parseFromString(html, "text/html");
//               const newCartDrawer = doc.querySelector("cart-drawer");
//               const currentCartDrawer = document.querySelector("cart-drawer");
              
//               if (newCartDrawer && currentCartDrawer) {
//                 currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
//                 document.dispatchEvent(new CustomEvent("cart:sections-updated"));
//               }
//             } catch (error) {
//               console.error("Error updating cart drawer in interval check:", error);
//             }
//           }
          
//           // Clear stored data and interval after 2 minutes
//           if (window.bundleCheckoutOpenTime === checkoutOpenTime) {
//             const timeSinceCheckout = Date.now() - checkoutOpenTime;
//             if (timeSinceCheckout > 120000) { // After 2 minutes, clear everything
//               sessionStorage.removeItem('bundleItemsForRestore');
//               clearInterval(purchaseCheckInterval);
//               if (window.bundleCheckoutInterval === purchaseCheckInterval) {
//                 window.bundleCheckoutInterval = null;
//               }
//               window.bundleCheckoutOpenTime = null;
//               document.removeEventListener('visibilitychange', visibilityHandler);
//               window.removeEventListener('focus', focusHandler);
//             }
//           }
//           } catch (error) {
//             console.error("Error in purchase check interval:", error);
//           }
//         }, 5000); // Check every 5 seconds
        
//         // Store interval ID and handlers so we can clear them if needed
//         window.bundleCheckoutInterval = purchaseCheckInterval;
//         window.bundleCheckoutVisibilityHandler = visibilityHandler;
//         window.bundleCheckoutFocusHandler = focusHandler;
//       }
    
//   } catch (error) {
//     console.error("Error adding items to Shopflo checkout:", error);
//     throw error;
//   }
// }

// Fallback: Add to Shopify cart then checkout
async function addItemsToShopifyCartThenCheckout(items, discountCode) {
  try {
    // Clear cart first
    await fetch("/cart/clear.js", { method: "POST" });
    
    // Add items
    for (const item of items) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: item.id,
          quantity: item.quantity,
          properties: item.properties
        })
      });
    }
    
    // Apply discount
    if (discountCode) {
      await fetch(`/discount/${discountCode}`, {
        method: 'GET',
        credentials: 'include'
      });
    }
    
    // Redirect to checkout
    // window.location.href = '/checkout';
    window.gokwikSdk.initCheckout(merchantInfo);
  } catch (error) {
    console.error("Error in fallback checkout:", error);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector(
    ".offer-add-to-cart .product-form__cart-submit"
  );
  const addToCartButtonText = document.querySelector(
    ".offer-add-to-cart .product-form__cart-submit span"
  );
  
  // const comboLimit = addToCartButton.getAttribute('data-combo-limit');
  const totalLimitContent = document.querySelector('.offer-collection-grid__product .tab-content');
  const totalLimit = totalLimitContent.getAttribute('data-total-limit');
  const replaceButton = document.getElementById("replaceButton");
  const closePopup = document.querySelector(".close-popup");
  const varientClosePopup = document.querySelector(".varient-close-popup");
  const openCart = document.querySelector(
    ".btn.btn--primary.btn--small.btn--full.open-cart"
  );
  let popupWrn;

  if (openCart) {
    openCart.addEventListener("click", async function () {
      await cartDrawer();
      addToCartButtonText.innerHTML = "Buy Now";
      addToCartButton.classList.remove("spinning");
      addToCartButton.disabled = false;
    });
  }

  if (closePopup) {
    closePopup.addEventListener("click", function (event) {
      event.preventDefault();
      popupWrn = document.querySelector(".popup-container.popup-style-2");
      popupWrn.classList.remove("active");
      addToCartButtonText.innerHTML = "Buy Now";
      addToCartButton.classList.remove("spinning");
      addToCartButton.disabled = false;
    });
  }

  if (varientClosePopup) {
    varientClosePopup.addEventListener("click", function (event) {
      event.preventDefault();
      popupWrns = varientClosePopup.parent;
      popupWrns.classList.remove("show");
      popupWrns.classList.add("hidden");
      addToCartButtonText.innerHTML = "Buy Now";
      addToCartButton.classList.remove("spinning");
      addToCartButton.disabled = false;
    });
  }

  if (addToCartButton) {
    addToCartButton.addEventListener("click", async function (event) {
      event.preventDefault();
      addToCartButtonText.innerHTML = "Creating";
      addToCartButton.disabled = true;
      addToCartButton.classList.add("spinning");
      
      try {
        // First, clear any previously stored bundle items data
        sessionStorage.removeItem('bundleItemsForRestore');
        window.bundleCheckoutOpenTime = null;
        
        // Clear any existing interval handlers
        if (window.bundleCheckoutInterval) {
          clearInterval(window.bundleCheckoutInterval);
          window.bundleCheckoutInterval = null;
        }
        if (window.bundleCheckoutVisibilityHandler) {
          document.removeEventListener('visibilitychange', window.bundleCheckoutVisibilityHandler);
          window.bundleCheckoutVisibilityHandler = null;
        }
        if (window.bundleCheckoutFocusHandler) {
          window.removeEventListener('focus', window.bundleCheckoutFocusHandler);
          window.bundleCheckoutFocusHandler = null;
        }
        
        // Clear ALL items from cart (both bundle items and simple products) before adding new bundle
        // console.log("Clearing all items from cart before adding new bundle...");
        // const clearCartResponse = await fetch("/cart/clear.js", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   }
        // });
        
        // if (!clearCartResponse.ok) {
        //   throw new Error("Failed to clear cart");
        // }
        
        // Minimal wait for cart to clear (reduced from 400ms)
        await new Promise(resolve => setTimeout(resolve, 100));
        
        console.log("totalLimit: ", totalLimit);
        const radioButtons = document.querySelectorAll(".button.select-btn");
        const selectedRadioData = [];
        
        radioButtons.forEach(function (radioButton) {
          if (radioButton.checked) {
            const radioData = radioButton.getAttribute("data-id-variant");
            selectedRadioData.push(radioData);
          }
        });

        if (selectedRadioData.length === 0) {
          console.warn("No product selected.");
          addToCartButtonText.innerHTML = "Buy Now";
          addToCartButton.disabled = false;
          addToCartButton.classList.remove("spinning");
          return;
        }

        let selectedRadioDatas = [];
        let totalQuantitySendToCart = [];
        let total = 0;

        radioButtons.forEach(function (radioButton) {
          if (radioButton.checked) {
            let radioData = radioButton.getAttribute("data-id-variant");
            let priceCurrent = radioButton.getAttribute("data-price-variant");
            let productQuantity = radioButton.getAttribute("data-quantity");
            let priceNumeric = parseFloat(priceCurrent);
            total += priceNumeric * productQuantity;
            selectedRadioDatas.push(radioData);
            totalQuantitySendToCart.push(productQuantity);
          }
        });

        console.log("total: ", total);
        
        let productIds = selectedRadioDatas;
        let mainOfferPrices = parseFloat(
          document.querySelector(".psptem").textContent.replace(/[^0-9.-]+/g, "")
        );
        let totalPrice = total;
        let offerPrice = mainOfferPrices;
        
        const currentDate = new Date();
        const formattedDate =
          currentDate.getFullYear().toString() +
          (currentDate.getMonth() + 1).toString().padStart(2, "0") +
          currentDate.getDate().toString().padStart(2, "0");

        const hashFormate = String(offerPrice.toString() + formattedDate);
        var hashResult = CryptoJS.MD5(hashFormate).toString(CryptoJS.enc.Hex);
        localStorage.setItem("comboTotalPrice", totalPrice);
        localStorage.setItem("comboOfferPrice", offerPrice);
                 
        const mainOfferTitle = document.querySelector(".prd-image-title h3").textContent;
        const mainOfferImage = document.querySelector(".prd-image-title img");
        const mainSrc = mainOfferImage ? mainOfferImage.getAttribute("src") : null;
        const mainOfferPrice = document.querySelector(".psptem").textContent;
        const currentUrl = window.location.href;

        // STEP 1: Prepare items array for Shopflo checkout
        console.log("Preparing items for Shopflo checkout...");
        const shopfloItems = [];
        for (let index = 0; index < selectedRadioData.length; index++) {
          shopfloItems.push({
            id: selectedRadioData[index],
            quantity: totalQuantitySendToCart[index],
            properties: {
              Offer: mainOfferTitle,
              Price: mainOfferPrice,
              Image: mainSrc,
              PageUrl: currentUrl,
              comboLimit: totalLimit,
              baseQuantity: totalQuantitySendToCart[index]
            }
          });
        }

        // STEP 2: Generate discount code
        console.log("Generating discount code...");
        const discountResult = await addTocartDiscount(productIds, totalPrice, offerPrice, hashResult);
        console.log("Discount result:", discountResult);
        
        // STEP 3: Add items directly to Shopflo checkout (bypassing visible cart)
        addToCartButtonText.innerHTML = "Redirecting to Checkout...";
        addToCartButton.classList.remove("spinning");
        addToCartButton.disabled = false;
        
        // Close cart drawer if open
        const checkoutDrawer = document.querySelector("cart-drawer");
        if (checkoutDrawer && typeof checkoutDrawer.close === "function") {
          checkoutDrawer.close();
        }
        addItemsToShopifyCartThenCheckout(shopfloItems, discountResult?.code);
        // Add items to Shopflo checkout directly
        // Note: Shopflo reads from Shopify cart, so we add items silently and immediately open checkout
        // try {
        //   await addItemsToShopfloCheckout(shopfloItems, discountResult?.code);
        // } catch (error) {
        //   console.error('Error adding items to Shopflo checkout:', error);
        //   // Fallback: Try standard method
        //   addItemsToShopifyCartThenCheckout(shopfloItems, discountResult?.code);
        // }
        
      } catch (error) { 
        console.error("Error adding to cart:", error);
        addToCartButtonText.innerHTML = "Error - Try Again";  
        addToCartButton.classList.remove("spinning");
        addToCartButton.disabled = false;
      }
    });
  }
  if (replaceButton) {
    replaceButton.addEventListener("click", async function (event) {
      event.preventDefault();

      try {
        replaceButton.disabled = true;
        replaceButton.classList.add("spinning");

        // Fetch current cart data via Cart API
        const cartResponse = await fetch("/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!cartResponse.ok) {
          throw new Error("Network response was not ok");
        }

        let cartData = await cartResponse.json();

        // Build updates object to remove all combo items
        const updates = {};

        cartData.items.forEach((item) => {
          // Check if item has 'Offer' property (combo item)
          if (item.properties && item.properties.Offer) {
            updates[item.key] = 0; // Set quantity to 0 to remove
          }
        });

        // If there are combo items to remove
        if (Object.keys(updates).length === 0) {
          console.warn("No combo items found in cart to replace");
          replaceButton.disabled = false;
          replaceButton.classList.remove("spinning"); 
          return;
        }

        // Remove old combo items using Cart API
        let updateCartResponse = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        });

        if (!updateCartResponse.ok) {
          throw new Error("Failed to remove old combo items");
        }

        let updatedCart = await updateCartResponse.json();
        console.log("Old combo items removed:", updatedCart);

        // Rest of your code to add new combo items
        let radioButtons = document.querySelectorAll(".button.select-btn");
        let selectedRadioDataas = [];
        let totalQuantitySendToCart = [];
        let total = 0;
      
        radioButtons.forEach(function (radioButton) {
          if (radioButton.checked) {
            let radioData = radioButton.getAttribute("data-id-variant");
            let priceCurrent = radioButton.getAttribute("data-price-variant");
            let productQuantity = radioButton.getAttribute("data-quantity");
            let priceNumeric = parseFloat(priceCurrent);
            total += priceNumeric * productQuantity;
            totalQuantitySendToCart.push(productQuantity);
            selectedRadioDataas.push(radioData);
          }
        });

        if (selectedRadioDataas.length === 0) {
          console.warn("No product selected.");
          replaceButton.disabled = false;
          replaceButton.classList.remove("spinning");
          return;
        }
        const selectedProducts = [];
        let selectedRadioDatas = [];
        selectedRadioDatas.forEach(function(variantId) {
          let existingItem = selectedProducts.find(item => item.variantId === variantId);
          if (existingItem) {
            existingItem.quantity += 1;
          } else {
            selectedProducts.push({
              variantId: variantId,
              quantity: 1
            });
          }
        });  
        let productIds = selectedRadioDataas;
        let mainOfferPrices = parseFloat(
          document
            .querySelector(".psptem")
            .textContent.replace(/[^0-9.-]+/g, "")
        );
        let totalPrice = total;
        let offerPrice = mainOfferPrices;
        const currentDate = new Date();
        const formattedDate =
          currentDate.getFullYear().toString() +
          (currentDate.getMonth() + 1).toString().padStart(2, "0") +
          currentDate.getDate().toString().padStart(2, "0");

        const hashFormate = String(offerPrice.toString() + formattedDate);
        var hashResult = CryptoJS.MD5(hashFormate).toString(CryptoJS.enc.Hex);
        localStorage.setItem("comboTotalPrice", totalPrice);
        localStorage.setItem("comboOfferPrice", offerPrice);
                    
        // Request to generate a discount code
        replaceCartDiscount(productIds, totalPrice, offerPrice, hashResult);

        // Add the new product to the cart
        const mainOfferTitle = document.querySelector(
          ".prd-image-title h3"
        ).textContent;
        const mainOfferImage = document.querySelector(".prd-image-title img");
        const mainOfferPrice = document.querySelector(".psptem").textContent;
        const mainSrc = mainOfferImage
          ? mainOfferImage.getAttribute("src")
          : null;
        const currentUrl = window.location.href;

        for (const product of selectedProducts) {
          await addProductWithRetry(
            product.variantId,
            product.quantity,
            {
              Offer: mainOfferTitle,
              Price: mainOfferPrice,
              Image: mainSrc,
              PageUrl: currentUrl,
              comboLimit: totalLimit,
              baseQuantity: product.quantity
            },
            3
          );
        }
        // Refresh cart drawer and re-initialize combo handlers
        updateCartBubble() 
        await cartDrawer();
        replaceButton.classList.remove("spinning");
        replaceButton.disabled = false;
        addToCartButtonText.innerHTML = "Buy Now";
        addToCartButton.classList.remove("spinning");
        addToCartButton.disabled = false;

        // Close popup
        popupWrn = document.querySelector(".popup-container.popup-style-2");
        if (popupWrn) {
          popupWrn.classList.remove("active");
        }
      } catch (error) {
        console.error("Error:", error);
        replaceButton.classList.remove("spinning");
        replaceButton.disabled = false;
      }
    });
  }
});
function updateCartBubble() {
    fetch(window.location.pathname + "?section_id=cart-icon-bubble")
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        console.log("doc for cart-bubble: ", doc);

        const newBubble = doc.querySelector("#shopify-section-cart-icon-bubble");
        const currentBubble = document.querySelector("#cart-icon-bubble");

        console.log("newBubble:", newBubble);
        console.log("currentBubble:", currentBubble);

        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
          console.log("Cart bubble updated successfully");
        } else {
          console.warn("Cart bubble not found on page.");
        }
      });
  }
async function updateCart() {
  try {
    const cartResponse = await fetch("/cart", {
      method: "GET",
    });

    if (!cartResponse.ok) {
      throw new Error("Network response was not ok");
    }

    let cartData = await cartResponse.text();

    const parser = new DOMParser();
    const cartHtml = parser.parseFromString(cartData, "text/html");

    const quickCartContainer = document.querySelector(".desktop_cart_item");
    const cartContainerHtml = cartHtml.querySelector(".desktop_cart_item");
    const quickCartContainerProgress = document.querySelector(
      ".cart-progressbar-index"
    );
    const cartContainerHtmlProgress = cartHtml.querySelector(
      ".cart-progressbar-index"
    );

    if (quickCartContainer && cartContainerHtml) {
      quickCartContainer.innerHTML = cartContainerHtml.innerHTML;
      if (quickCartContainerProgress && cartContainerHtmlProgress) {
        quickCartContainerProgress.innerHTML =
          cartContainerHtmlProgress.innerHTML;
      }
      // loadScript();
    } else {
      // window.location.href = '/cart';
      // document.querySelector('cart-drawer').open();
      updateCartBubble() 
      await cartDrawer();
      console.error(
        "No .quick-cart__container element found in the response HTML or on the page."
      );
    }
  } catch (error) {
    console.error("Error updating the cart:", error);
  }
}

async function addProductWithRetry(productId, productQuantity, properties, retries) {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      await new Promise((resolve) => setTimeout(resolve, 300));
      await addProductToCartMin(productId, productQuantity, properties);
      break;
    } catch (error) {
      console.error(
        `Failed to add product ID ${productId} to cart (attempt ${attempt}):`,
        error
      );
      if (attempt === retries) {
        console.error(`Giving up after ${retries} attempts`);
      }
    }
  }
}

async function addProductToCartMin(productId, productQuantity, properties) {
  const data = {
    quantity: productQuantity,
    id: productId,
    properties: properties,
  };
  console.log("data: ", data);

  try {
    let response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error adding product to cart:", error);
    throw error;
  }
}

const cartDrawer = async (openDrawer = true) => {
  try {
    const res = await fetch("/cart?section_id=cart-drawer");
    const html = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const newCartDrawer = doc.querySelector("cart-drawer");
    const currentCartDrawer = document.querySelector("cart-drawer");

    if (newCartDrawer && currentCartDrawer) {
      // Replace the entire element to ensure internal state (web component shadow DOM, event handlers)
      const replacement = newCartDrawer.cloneNode(true);
      currentCartDrawer.replaceWith(replacement);
      // Allow re-initializing combo handlers after cart refresh
      replacement.comboHandlersInitialized = false;
      // Notify other scripts that cart sections were updated
      document.dispatchEvent(new CustomEvent("cart:sections-updated"));
    }

    // Optionally open the drawer
    if (openDrawer) {
      const drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    }
  } catch (error) {
    console.error("Error loading cart drawer:", error);
  }
};  